module.exports = __webpack_public_path__ + "img/9791190422369.46ab4485.jpg";